import { Switch as HeadlessSwitch } from '@headlessui/react';
import React, { ComponentPropsWithoutRef, FC, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export type SwitchProps = {
  disableChange?: boolean;
  disabled?: boolean;
  enabled?: boolean;
  onSelect?: (state: boolean) => void;
  toggleClassName?: string;
} & ComponentPropsWithoutRef<typeof HeadlessSwitch>;

export const Switch: FC<SwitchProps> = ({
  onChange,
  className,
  toggleClassName,
  checked,
  enabled: enabledState = false,
  disabled = false,
  disableChange,
  ...props
}) => {
  const [enabled, setEnabled] = useState(enabledState);

  const handleEnabled = (state: boolean) => {
    if (disabled) return;

    onChange?.(state);
    if (disableChange) return;
    setEnabled(state);
  };

  useEffect(() => {
    setEnabled(enabledState);
  }, [enabledState]);

  return (
    <HeadlessSwitch
      checked={checked || enabled}
      className={twMerge(
        'group relative flex h-5 w-9 shrink-0 cursor-pointer rounded-full bg-gray-100 transition-colors duration-200 ease-in-out data-[checked]:bg-forest-500',
        disabled ? 'cursor-not-allowed data-[checked]:bg-gray-300' : '',
        className,
      )}
      defaultChecked={checked}
      onChange={handleEnabled}
      {...props}
    >
      <span
        aria-hidden="true"
        className={twMerge(
          'pointer-events-none inline-block size-4 shrink-0 translate-x-[2px] translate-y-[2px] rounded-full bg-white shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-[18px]',
          toggleClassName,
        )}
      />
    </HeadlessSwitch>
  );
};
